export default __webpack_public_path__ + "static/media/CapitaSprintShowcase.jpg?.e5f0d70a";